<template>
  <div class="cv-content">
    <div class="remarks container_ctrl">
      <el-row>
        <el-col :span="6">
          <user-avatar :src="basic_info.photo" class="useravatar-middle" @click="viewUserAvatar = true">
          </user-avatar>
        </el-col>
        <el-col :span="18">
          <el-row>
            <el-col :span="22">
              {{basic_info.name}}&nbsp;</el-col>
            <el-col :span="2">
              <a class="icon_ctrl editicon2x" @click="editBasicInfo = true"></a>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="impmsg">
              <span v-if="basic_info.sex">{{basic_info.sex}}</span>
              <span v-if="basic_info.birth">{{this.$Shared.calcAge(basic_info.birth)}}岁</span>
              <span>{{basic_info.work_year > 0 ? basic_info.work_year + "年工作经验" : "工作经验未知"}}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              户&#12288;&#12288;籍：{{basic_info.native_city}}
            </el-col>
            <el-col :span="12">
              居住地址：{{basic_info.live_city}}
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              出生日期：{{this.$Shared.formatDate(basic_info.birth)}}
            </el-col>
            <el-col :span="12">
              婚姻状况：{{basic_info.married_status}}
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12" v-if="basic_info.height > 0">
              身&#12288;&#12288;高：{{basic_info.height}}cm
            </el-col>
            <el-col :span="12" v-if="basic_info.weight > 0">
              体&#12288;&#12288;重：{{basic_info.weight}}kg
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>

    <!-- 求职意向 -->
    <div class="remarks container_ctrl" @mouseenter="workExpectIcon = true" @mouseleave="workExpectIcon = false">
      <h1 class="">求职意向
        <a class="icon_ctrl editicon2x" @click="editWorkExpect = true"></a>
      </h1>
      <div class="infobox">
        <el-row>
          <el-col :span="12">
            工作性质：{{work_expect.job_natures}}
          </el-col>
          <el-col :span="12">
            意向城市：{{work_expect.citys}}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            意向职能：{{work_expect.positions}}
          </el-col>
          <el-col :span="12">
            期望月薪：{{work_expect.min_salary}}K - {{work_expect.max_salary}}K
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 教育经历 -->
    <div class="remarks">
      <h1 class="abc">
        教育经历
        <el-tooltip content="新增教育经历" placement="top">
          <a class="addicon" @click="addEdu = true"></a>
        </el-tooltip>
      </h1>
      <div>
        <ul>
          <li v-for="(item,index) in edu_exp" :key="index" class="container_ctrl">
            <el-row>
              <el-col :span="10">
                {{item.start_date}} - {{item.end_date}}
              </el-col>
              <el-col :span="10">
                {{item.school_name}}
                <el-tooltip content="已认证学历，无法编辑和删除" placement="top">
                  <i v-if="item.verify_state == 3" class="icon_verified"></i>
                </el-tooltip>
              </el-col>
              <el-col :span="2">
                <a v-if="item.verify_state != 3" @click="eduExpDel(item.exp_id)" class="icon_ctrl closeicon"></a>
              </el-col>
              <el-col :span="2">
                <a v-if="item.verify_state != 3" @click="editEduExp(item)" class="icon_ctrl editicon2x"></a>
              </el-col>
            </el-row>
            <el-row class="impmsg">
              <span v-if="item.degree">{{item.degree}}</span>
              <span v-if="item.major">{{item.major}}</span>
              <span v-if="item.edu_mode">{{item.edu_mode}}</span>
            </el-row>
          </li>
        </ul>
      </div>
    </div>

    <!-- 工作经历 -->
    <div class="remarks">
      <h1 class="abc">
        工作经历
        <el-tooltip content="新增工作经历" placement="top">
          <a class="addicon" @click="addWork = true"></a>
        </el-tooltip>
      </h1>
      <div>
        <ul>
          <li v-for="(item,index) in work_exp" :key="index" class="container_ctrl">
            <!-- <i class="remarksicon2x"></i> -->
            <el-row>
              <el-col :span="20">
                {{item.start_date}} - {{item.end_date}}
              </el-col>
              <el-col :span="2">
                <a @click="workExpDel(item.exp_id)" class="icon_ctrl closeicon"></a>
              </el-col>
              <el-col :span="2">
                <a @click="editWorkExp(item)" class="icon_ctrl editicon2x"></a>
              </el-col>
            </el-row>
            <el-row>
              {{item.company_name}}
            </el-row>
            <el-row>
              <el-col :span="24" class="impmsg">
                <span v-if="item.position">{{item.position}}</span>
                <span v-if="item.department">{{item.department}}</span>
              </el-col>
            </el-row>
            <el-row class="impmsg">
              <span v-if="item.industry">{{item.industry}}</span>
              <span v-if="item.company_size">{{item.company_size}}</span>
              <span v-if="item.company_type">{{item.company_type}}</span>
            </el-row>
            <el-row class="impmsg">工作描述：</el-row>
            <el-row>
              <p class="desc" v-html="$Shared.replaceBreakLine(item.description)"></p>
            </el-row>
          </li>
        </ul>
      </div>
    </div>

    <!-- 项目经验 -->
    <div class="remarks">
      <h1 class="abc">
        项目经验
        <el-tooltip content="新增项目经验" placement="top">
          <a class="addicon" @click="addProject = true"></a>
        </el-tooltip>        
      </h1>
      <div>
        <ul>
          <li v-for="(item,index) in project_exp" :key="index" class="container_ctrl">
            <!-- <i class="remarksicon2x"></i> -->
            <el-row>
              <el-col :span="20">
                {{item.start_date}} - {{item.end_date}}
              </el-col>
              <el-col :span="2">
                <a @click="projectExpDel(item.exp_id)" class="icon_ctrl closeicon"></a>
              </el-col>
              <el-col :span="2">
                <a @click="editProjectExp(item)" class="icon_ctrl editicon2x"></a>
              </el-col>
            </el-row>
            <el-row class="impmsg">{{item.project_name}}</el-row>
            <el-row>
              所属公司：{{item.company}}
            </el-row>
            <el-row class="impmsg">项目描述：</el-row>
            <el-row>
              <p class="desc" v-html="$Shared.replaceBreakLine(item.description)"></p>
            </el-row>
          </li>
        </ul>
      </div>
    </div>

    <!-- 专业技能 -->
    <div class="remarks container_ctrl">
      <h1 class="">
        专业技能
        <a class="icon_ctrl editicon2x" @click="editProfessionalSkill = true"></a>
      </h1>
      <div class="infobox">
        <el-row v-for="(item,index) in professional_skill" :key="index">
          {{item.name}}：{{item.level}}
        </el-row>
      </div>
    </div>

    <!-- 证书 -->
    <div class="remarks container_ctrl">
      <h1 class="">
        证书
        <a class="icon_ctrl editicon2x" @click="editCertificate = true"></a>
      </h1>
      <div class="infobox">
        <el-row v-for="(item,index) in certificate" :key="index">
          {{item.name}}
        </el-row>
      </div>
    </div>

    <!-- 语言能力 -->
    <div class="remarks container_ctrl">
      <h1 class="">
        语言能力
        <a class="icon_ctrl editicon2x" @click="editLanguageSkill = true"></a>
      </h1>
      <div class="infobox">
        <el-row v-for="(item,index) in language_skill" :key="index">
          {{item.name}}：{{item.level}}
        </el-row>
      </div>
    </div>

    <!-- 自我评价 -->
    <div class="remarks container_ctrl">
      <h1 class="">
        自我评价
        <a class="icon_ctrl editicon2x" @click="editSelfEvaluation = true"></a>
      </h1>
      <div class="infobox">
        <p class="desc" v-html="$Shared.replaceBreakLine(self_evaluation)"></p>
      </div>
    </div>

    <!-- 附加信息——其他 -->
    <div class="remarks container_ctrl">
      <h1 class="">
        附加信息（兴趣爱好）
        <a class="icon_ctrl editicon2x" @click="editAdditionalInfo = true"></a>
      </h1>
      <div class="infobox">
        <p class="desc" v-html="$Shared.replaceBreakLine(additional_info)"></p>
      </div>
    </div>

    <!-- 头像 -->
    <el-dialog append-to-body top="3vh" custom-class="preview-image" :visible.sync="viewUserAvatar">
      <img class="js-preview-image" :src="basic_info.photo" />
    </el-dialog>

    <basicInfo :data="basic_info" :visible="editBasicInfo" @visibleChange="basicInfoVisibleChange"
      @change="basicInfoChange"></basicInfo>
    <workExpect :data="work_expect" :visible="editWorkExpect" @visibleChange="workExpectVisibleChange"
      @change="workExpectChange"></workExpect>
    <eduAdd :ResumeID="resumeId" :visible="addEdu" @visibleChange="eduAddVisibleChange" @change="onEduAdd">
    </eduAdd>
    <eduEdit :data="edu_item" :visible="editEdu" @visibleChange="eduEditVisibleChange" @change="onEduEdit">
    </eduEdit>
    <workAdd :ResumeID="resumeId" :visible="addWork" @visibleChange="workAddVisibleChange" @change="onWorkAdd">
    </workAdd>
    <workEdit :data="work_item" :visible="editWork" @visibleChange="workEditVisibleChange" @change="onWorkEdit">
    </workEdit>
    <projectAdd :ResumeID="resumeId" :visible="addProject" @visibleChange="projectAddVisibleChange"
      @change="onProjectAdd"></projectAdd>
    <projectEdit :data="project_item" :visible="editProject" @visibleChange="projectEditVisibleChange"
      @change="onProjectEdit"></projectEdit>

    <certificate :data="certificate" :visible="editCertificate" @visibleChange="certificateVisibleChange"
      @change="certificateChange"></certificate>

    <languageSkill :data="language_skill" :visible="editLanguageSkill" @visibleChange="languageSkillVisibleChange"
      @change="languageSkillChange"></languageSkill>

    <professionalSkill :data="professional_skill" :visible="editProfessionalSkill"
      @visibleChange="professionalSkillVisibleChange" @change="professionalSkillChange"></professionalSkill>

    <selfEvaluation :data="self_evaluation" :visible="editSelfEvaluation" @visibleChange="selfEvaluationVisibleChange"
      @change="selfEvaluationChange"></selfEvaluation>

    <additionalInfo :data="additional_info" :visible="editAdditionalInfo" @visibleChange="additionalInfoVisibleChange"
      @change="additionalInfoChange"></additionalInfo>
  </div>
</template>

<script>
  import {
    getBasicInfo,
    getJobExpect,
    getEduExp,
    getWorkExp,
    getProjectExp,
    getProfessionalSkill,
    getCertificate,
    getLanguageSkill,
    getSelfEvaluation,
    getAdditionalInfo,
    operateBasicInfo,
    operateJobExpect,
    operateEdu,
    delEdu,
    operateWork,
    delWork,
    operateProject,
    delProject,
    operateCertificate,
    operateLanguageSkill,
    operateProfessionalSkill,
    operateSelfEvaluation,
    operateAdditionalInfo
  } from '~/api/resume';

  import userAvatar from './UserAvatar';
  import basicInfo from './ResumeBasicInfo';
  import workExpect from './ResumeWorkExpect';
  import eduAdd from './ResumeEduAdd';
  import eduEdit from './ResumeEduEdit';
  import workAdd from './ResumeWorkAdd';
  import workEdit from './ResumeWorkEdit';
  import projectAdd from './ResumeProjectAdd';
  import projectEdit from './ResumeProjectEdit';
  import certificate from './ResumeCertificate';
  import languageSkill from './ResumeLanguageSkill';
  import professionalSkill from './ResumeProfessionalSkill';
  import selfEvaluation from './ResumeSelfEvaluation';
  import additionalInfo from './ResumeAdditionalInfo';

  export default {
    name: 'ResumeInfo',
    components: {
      userAvatar,
      basicInfo,
      workExpect,
      eduAdd,
      eduEdit,
      workAdd,
      workEdit,
      projectAdd,
      projectEdit,
      certificate,
      languageSkill,
      professionalSkill,
      selfEvaluation,
      additionalInfo
    },
    props: {
      resumeId: {
        type: Number,
        default: 0
      },
    },
    data() {
      return {
        viewUserAvatar: false,
        editBasicInfo: false,
        editWorkExpect: false,
        addEdu: false,
        editEdu: false,
        addWork: false,
        editWork: false,
        addProject: false,
        editProject: false,
        editProfessionalSkill: false,
        editCertificate: false,
        editLanguageSkill: false,
        editSelfEvaluation: false,
        editAdditionalInfo: false,
        basic_info: {},
        work_expect: {},
        edu_exp: [],
        work_exp: [],
        project_exp: [],
        professional_skill: [],
        certificate: [],
        language_skill: [],
        self_evaluation: '',
        additional_info: '',
        edu_item: {},
        work_item: {},
        project_item: {},
      };
    },
    created() {
      if (this.resumeId) {
        this.getBasicInfo();
        this.getJobExpect();
        this.getEduExp();
        this.getWorkExp();
        this.getProjectExp();
        this.getProfessionalSkill();
        this.getCertificate();
        this.getLanguageSkill();
        this.getSelfEvaluation();
        this.getAdditionalInfo();
      }
    },
    methods: {
      getBasicInfo() {
        var params = {
          resume_id: this.resumeId
        };
        getBasicInfo(params).then(m => {
          if (m.errcode === 0) {
            this.basic_info = m.data;
          } else {
            this.$message.error(m.errmsg);
          }
        });
      },
      getJobExpect() {
        var params = {
          resume_id: this.resumeId
        };
        getJobExpect(params).then(m => {
          if (m.errcode === 0) {
            this.work_expect = m.data;
          }
        });
      },
      getEduExp() {
        var params = {
          resume_id: this.resumeId
        };
        getEduExp(params).then(m => {
          if (m.errcode === 0) {
            this.edu_exp = m.data;
          }
        });
      },
      getWorkExp() {
        var params = {
          resume_id: this.resumeId
        };
        getWorkExp(params).then(m => {
          if (m.errcode === 0) {
            this.work_exp = m.data;
          }
        });
      },
      getProjectExp() {
        var params = {
          resume_id: this.resumeId
        };
        getProjectExp(params).then(m => {
          if (m.errcode === 0) {
            this.project_exp = m.data;
          }
        });
      },
      getProfessionalSkill() {
        var params = {
          resume_id: this.resumeId
        };
        getProfessionalSkill(params).then(m => {
          if (m.errcode === 0) {
            this.professional_skill = m.data;
          }
        });
      },
      getCertificate() {
        var params = {
          resume_id: this.resumeId
        };
        getCertificate(params).then(m => {
          if (m.errcode === 0) {
            this.certificate = m.data;
          }
        });
      },
      getLanguageSkill() {
        var params = {
          resume_id: this.resumeId
        };
        getLanguageSkill(params).then(m => {
          if (m.errcode === 0) {
            this.language_skill = m.data;
          }
        });
      },
      getSelfEvaluation() {
        var params = {
          resume_id: this.resumeId
        };
        getSelfEvaluation(params).then(m => {
          if (m.errcode === 0) {
            this.self_evaluation = m.data;
          }
        });
      },
      getAdditionalInfo() {
        var params = {
          resume_id: this.resumeId
        };
        getAdditionalInfo(params).then(m => {
          if (m.errcode === 0) {
            this.additional_info = m.data;
          }
        });
      },
      eduExpDel(exp_id) {
        this.$confirm('确认删除此段经历?', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            delEdu({
              exp_id: exp_id
            }).then(m => {
              if (m.errcode == 0) {
                this.$message.success('删除成功');
                let index = this.edu_exp.findIndex(x => x.exp_id == exp_id);
                this.edu_exp.splice(index, 1);
              } else {
                this.$message.error('删除失败，原因：' + m.errmsg);
              }
            });
          })
          .catch(() => {});
      },
      editEduExp(edu_item) {
        this.edu_item = edu_item;
        this.editEdu = true;
      },
      workExpDel(exp_id) {
        this.$confirm('确认删除此段经历?', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            delWork({
              exp_id: exp_id
            }).then(m => {
              if (m.errcode == 0) {
                this.getWorkExp();
              } else {
                this.$message.error('删除失败，原因：' + m.errmsg);
              }
            });
          })
          .catch(() => {});
      },
      editWorkExp(work_item) {
        this.work_item = work_item;
        this.editWork = true;
      },
      projectExpDel(exp_id) {
        this.$confirm('确认删除此段经验?', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            delProject({
              exp_id: exp_id
            }).then(m => {
              if (m.errcode == 0) {
                this.getProjectExp();
              } else {
                this.$message.error('删除失败，原因：' + m.errmsg);
              }
            });
          })
          .catch(() => {});
      },
      editProjectExp(project_item) {
        this.project_item = project_item;
        this.editProject = true;
      },
      basicInfoVisibleChange(val) {
        this.editBasicInfo = val;
      },
      basicInfoChange(data) {
        operateBasicInfo(data).then(m => {
          if (m.errcode == 0) {
            this.$message.success('编辑基本信息成功');
            this.getBasicInfo();
          } else {
            this.$message.error('编辑基本信息失败,失败信息：' + m.errmsg);
          }
        });
      },
      workExpectVisibleChange(val) {
        this.editWorkExpect = val;
      },
      workExpectChange(data) {
        operateJobExpect(data).then(m => {
          if (m.errcode == 0) {
            this.$message.success('编辑求职意向成功');
            this.getJobExpect();
          } else {
            this.$message.error('编辑求职意向失败,失败信息：' + m.errmsg);
          }
        });
      },
      eduAddVisibleChange(val) {
        this.addEdu = val;
      },
      onEduAdd(data) {
        operateEdu(data).then(m => {
          if (m.errcode == 0) {
            this.$message.success('添加教育成功');
            this.getEduExp();
          } else {
            this.$message.error('添加教育经历失败,失败信息：' + m.errmsg);
          }
        });
      },
      eduEditVisibleChange(val) {
        this.editEdu = val;
      },
      onEduEdit(data) {
        operateEdu(data).then(m => {
          if (m.errcode == 0) {
            this.$message.success('编辑教育经历成功');
            this.getEduExp();
          } else {
            this.$message.error('编辑教育经历失败,失败信息：' + m.errmsg);
          }
        });
      },
      workAddVisibleChange(val) {
        this.addWork = val;
      },
      onWorkAdd(data) {
        operateWork(data).then(m => {
          if (m.errcode == 0) {
            this.$message.success('添加工作经历成功');
            this.getWorkExp();
          } else {
            this.$message.error('添加工作经历失败,失败信息：' + m.errmsg);
          }
        });
      },
      workEditVisibleChange(val) {
        this.editWork = val;
      },
      onWorkEdit(data) {
        operateWork(data).then(m => {
          if (m.errcode == 0) {
            this.$message.success('编辑工作经历成功');
            this.getWorkExp();
          } else {
            this.$message.error('编辑工作经历失败,失败信息：' + m.errmsg);
          }
        });
      },
      projectAddVisibleChange(val) {
        this.addProject = val;
      },
      onProjectAdd(data) {
        operateProject(data).then(m => {
          if (m.errcode == 0) {
            this.$message.success('添加项目经验成功');
            this.getProjectExp();
          } else {
            this.$message.error('添加项目经验失败,失败信息：' + m.errmsg);
          }
        });
      },
      projectEditVisibleChange(val) {
        this.editProject = val;
      },
      onProjectEdit(data) {
        operateProject(data).then(m => {
          if (m.errcode == 0) {
            this.$message.success('编辑项目经验成功');
            this.getProjectExp();
          } else {
            this.$message.error('编辑项目经验失败,失败信息：' + m.errmsg);
          }
        });
      },
      certificateVisibleChange(val) {
        this.editCertificate = val;
      },
      certificateChange(content) {
        let data = {
          resume_id: this.resumeId,
          content: content
        };
        operateCertificate(data).then(m => {
          if (m.errcode == 0) {
            this.$message.success('编辑证书成功');
            this.getCertificate();
          } else {
            this.$message.error('编辑证书失败,失败信息：' + m.errmsg);
          }
        });
      },
      languageSkillVisibleChange(val) {
        this.editLanguageSkill = val;
      },
      languageSkillChange(content) {
        let data = {
          resume_id: this.resumeId,
          content: content
        };
        operateLanguageSkill(data).then(m => {
          if (m.errcode == 0) {
            this.$message.success('编辑语言能力成功');
            this.getLanguageSkill();
          } else {
            this.$message.error('编辑语言能力失败,失败信息：' + m.errmsg);
          }
        });
      },
      professionalSkillVisibleChange(val) {
        this.editProfessionalSkill = val;
      },

      professionalSkillChange(content) {
        let data = {
          resume_id: this.resumeId,
          content: content
        };
        operateProfessionalSkill(data).then(m => {
          if (m.errcode == 0) {
            this.$message.success('编辑专业技能成功');
            this.getProfessionalSkill();
          } else {
            this.$message.error('编辑专业技能失败,失败信息：' + m.errmsg);
          }
        });
      },

      selfEvaluationVisibleChange(val) {
        this.editSelfEvaluation = val;
      },

      selfEvaluationChange(content) {
        let data = {
          resume_id: this.resumeId,
          content: content
        };
        operateSelfEvaluation(data).then(m => {
          if (m.errcode == 0) {
            this.$message.success('编辑自我评价成功');
            this.getSelfEvaluation();
          } else { 
            this.$message.error('编辑自我评价失败,失败信息：' + m.errmsg);
          }
        });
      },

      additionalInfoVisibleChange(val) {
        this.editAdditionalInfo = val;
      },

      additionalInfoChange(content) {
        let data = {
          resume_id: this.resumeId,
          content: content
        };
        operateAdditionalInfo(data).then(m => {
          if (m.errcode == 0) {
            this.$message.success('编辑附加信息成功');
            this.getAdditionalInfo();
          } else {
            this.$message.error('编辑附加信息失败,失败信息：' + m.errmsg);
          }
        });
      },
    }
  };
</script>

<style scoped>
  h1 {
    margin: 5px 0 10px 0;
  }

  .el-row {
    margin-bottom: 10px;
  }
</style>